<form [formGroup]="form" class="flex flex-col space-y-5">
    <app-page-header-nav
        title="Edit Account"
        [navItems]="pageHeaderNavItems"
    ></app-page-header-nav>

    <div class="flex flex-col lg:grid lg:grid-cols-2 lg:gap-20 px-5 max-w-5xl">
        <div>
            <section class="flex space-x-3">
                <div class="flex flex-col w-full space-y-5">
                    <p class="font-medium !m-0">Username:</p>
                    <p>{{ this.form.controls.username.value }}</p>
                </div>

                <div class="w-full">
                    <p class="font-medium">Role:</p>
                    <app-role-input formControlName="role"></app-role-input>
                </div>
            </section>

            <section class="w-full">
                <p class="font-medium">Name:</p>
                <div class="flex space-x-3">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>First Name</mat-label>
                        <input
                            title="First name"
                            matInput
                            [pattern]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                            [minlength]="
                                htmlInputConstants.FIRST_NAME_MIN_LENGTH
                            "
                            [maxlength]="
                                htmlInputConstants.FIRST_NAME_MAX_LENGTH
                            "
                            formControlName="firstName"
                        />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Last Name</mat-label>
                        <input
                            title="Last name"
                            matInput
                            [pattern]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                            [minlength]="
                                htmlInputConstants.LAST_NAME_MIN_LENGTH
                            "
                            [maxlength]="
                                htmlInputConstants.LAST_NAME_MAX_LENGTH
                            "
                            formControlName="lastName"
                        />
                    </mat-form-field>
                </div>
            </section>

            <section>
                <p class="font-medium">Email:</p>
                <p>{{ this.form.controls.email.value }}</p>
            </section>

            <section class="mb-6">
                <p class="font-medium">Company/Organization:</p>
                <p>{{ profileResponse?.organization?.name }}</p>
            </section>

            <section class="mb-6">
                <p class="font-medium">Company/Organization Type:</p>
                <p>{{ profileResponse?.organization?.organizationType }}</p>
            </section>

            <section>
                <p class="font-medium">Job Title:</p>
                <mat-form-field appearance="outline" class="w-full">
                    <input
                        title="Job title"
                        matInput
                        [minlength]="htmlInputConstants.JOB_TITLE_MIN_LENGTH"
                        [maxlength]="htmlInputConstants.JOB_TITLE_MAX_LENGTH"
                        [pattern]="
                            regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                        formControlName="jobTitle"
                    />
                </mat-form-field>
            </section>

            <section>
                <p class="font-medium">Company Address:</p>
                <mat-form-field appearance="outline" class="w-full">
                    <input
                        title="Company Address or PO Box"
                        matInput
                        [minlength]="
                            htmlInputConstants.STREET_ADDRESS_MIN_LENGTH
                        "
                        [maxlength]="
                            htmlInputConstants.STREET_ADDRESS_MAX_LENGTH
                        "
                        [pattern]="
                            regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                        spellcheck="false"
                        formControlName="streetAddress"
                    />
                </mat-form-field>

                <div class="grid grid-cols-3 gap-2">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>City</mat-label>
                        <input
                            title="City"
                            matInput
                            [minlength]="htmlInputConstants.CITY_MIN_LENGTH"
                            [maxlength]="htmlInputConstants.CITY_MAX_LENGTH"
                            [pattern]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                            formControlName="city"
                        />
                    </mat-form-field>

                    <app-state-province-input
                        formControlName="stateProvinceId"
                    ></app-state-province-input>

                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>ZIP Code</mat-label>
                        <input
                            title="ZIP code"
                            matInput
                            [pattern]="regExPattern.MaskedPostalCode"
                            [imask]="maskOptions.postalCode"
                            [unmask]="false"
                            formControlName="postalCode"
                        />
                    </mat-form-field>
                </div>
            </section>

            <section>
                <p class="font-medium">Direct Phone Number:</p>
                <app-phone-number-input
                    title="Direct phone number"
                    [control]="form.controls.phoneNumber"
                    [withExtension]="true"
                ></app-phone-number-input>
            </section>
        </div>

        <div>
            <section>
                <p class="font-medium">Account Status:</p>
                <div class="inline-flex rounded-md mb-6" role="group">
                    <label
                        for="active"
                        tabindex="0"
                        (keydown.enter)="form.controls.isActive?.setValue(true)"
                        [class]="
                            form.controls.isActive?.value === true
                                ? 'bg-primary-100 text-primary-800'
                                : 'text-tertiary-900 hover:bg-tertiary-100'
                        "
                        class="relative flex items-center px-5 py-2 text-sm font-medium border rounded-l-md cursor-pointer border-tertiary-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary-700"
                    >
                        <input
                            id="active"
                            type="radio"
                            formControlName="isActive"
                            [value]="true"
                            class="sr-only"
                            tabindex="-1"
                        />
                        <mat-icon class="scale-75 me-2" aria-hidden="true"
                            >check</mat-icon
                        >
                        Active
                    </label>

                    <label
                        for="inactive"
                        tabindex="0"
                        (keydown.enter)="
                            form.controls.isActive?.setValue(false)
                        "
                        [class]="
                            form.controls.isActive?.value === false
                                ? 'bg-error-100 text-error-800'
                                : 'text-tertiary-900 hover:bg-tertiary-100'
                        "
                        class="relative inline-flex items-center px-5 py-2 text-sm font-medium border rounded-r-md cursor-pointer border-tertiary-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary-700"
                    >
                        <input
                            id="inactive"
                            type="radio"
                            formControlName="isActive"
                            [value]="false"
                            class="sr-only"
                            tabindex="-1"
                        />
                        <mat-icon class="scale-75 me-2">close</mat-icon>
                        Inactive
                    </label>
                </div>
            </section>

            <section>
                <div class="flex flex-row space-x-3 items-end">
                    <div class="flex flex-col">
                        <p class="font-medium">Email Verified:</p>
                        <p class="text-sm">
                            {{
                                this.profileResponse?.isEmailVerified === true
                                    ? 'Yes'
                                    : this.profileResponse?.isEmailVerified ===
                                        false
                                      ? 'No'
                                      : 'Unknown'
                            }}
                        </p>
                    </div>
                    @if (this.profileResponse?.isEmailVerified === false) {
                        <button
                            mat-flat-button
                            type="button"
                            name="resend-verification-email"
                            color="primary"
                            class="!rounded-lg mb-2"
                            (click)="sendVerificationEmail()"
                        >
                            Resend Verification
                        </button>
                    }
                </div>
            </section>
        </div>
    </div>
</form>
